import React, { Suspense } from 'react';
import AppRoot from './AppRoot';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initAppWindowEvents } from './services/flowManager';
import { initFS } from './services/fullStoryManager';
import { Box } from '@mui/material';
import { Loader } from './components/Loader';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

initAppWindowEvents();
initFS();
const container = document.getElementById('root');
const root = createRoot(container!);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense
        fallback={
          <Box height="100vh">
            <Loader />
          </Box>
        }
      >
        <BrowserRouter basename="/v2">
          <AppRoot />
        </BrowserRouter>
      </Suspense>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
